import React from 'react';

// variant: 'new' | 'premium' | 'free' | 'platform' (text only — never Apple/Android logos)
const MkPill = ({ variant = 'platform', className, children, ...rest }) => (
  <span {...rest} className={['mk-pill', `mk-pill--${variant}`, className].filter(Boolean).join(' ')}>
    {children}
  </span>
);

export default MkPill;
